import React, { useEffect, useContext } from 'react';
import ComingSoon from './common/ComingSoon';
import Context from '../context/Context';

const Settings = () => {
  const { setPageTitle } = useContext(Context);

  useEffect(() => {
    setPageTitle('Settings');
  }, [setPageTitle]);

  return (
    <ComingSoon />
  );
};

export default Settings;
